import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { concatMap, tap } from 'rxjs/operators';
import { NgrxService } from 'src/app/services';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ProfileSearchService {
	serviceName = 'profileSearch';
	randomId = '0';

	constructor(
		private http: HttpClient,
		private store: Store<any>,
		private ngrxService: NgrxService,
	) {}

	loadSearchProfileApi(filter: any = {}) {
		this.randomId = String(Math.random());

		let payload: any = {
			id: this.randomId,
			name: 'Search profiles v2',
			searchQuery: { 'roles.id': ['1', '2', '3', '4', '7'], ...filter },
			searchOpt: {},
			boolQuery: {},
		};

		if ('sortBy' in payload.searchQuery) {
			delete payload.searchQuery.sortBy;
			payload.sortBy = filter.sortBy;
		}

		if ('profileId' in payload.searchQuery) {
			delete payload.searchQuery.profileId;
			payload.profileId = filter.profileId;
		}

		return this.ngrxService.loadInitAPI(this.serviceName, 'search').pipe(
			tap(() => console.log('filter', filter)),
			concatMap(() =>
				this.http.post<any>(`${environment.url.profile}/search/limit/20`, [
					payload,
				]),
			),
			tap(data => {
				this.updateData(data[0]?.result, data[0]?.total);
			}),
		);
	}

	updateData(records, total) {
		return this.ngrxService.loadInitDataPagination(
			this.serviceName,
			'search',
			records,
			total,
		);
	}
	loadMoreSearchProfileApi(filter: any = {}, after: any) {
		return this.ngrxService.loadMoreInitAPI(this.serviceName, 'search').pipe(
			concatMap(() =>
				this.http.post<any>(`${environment.url.profile}/search/limit/20`, [
					{
						id: this.randomId,
						name: 'Search profiles v2',
						searchQuery: { 'roles.id': ['1', '2', '3', '4', '7'], ...filter },
						after,
					},
				]),
			),
			tap(data => {
				this.ngrxService.loadMoreDataPagination(
					this.serviceName,
					'search',
					data[0]?.result,
				);
			}),
		);
	}

	loadSearchProfileInit() {
		this.ngrxService.init(this.serviceName, 'search');
	}

	loadSearchProfileData() {
		return this.ngrxService.loadData(this.serviceName, 'search');
	}

	loadFilterData() {
		return this.ngrxService.loadFilter(this.serviceName, 'search');
	}

	loadFilterProfileApi(filter: any = {}) {
		this.ngrxService.setFilter(this.serviceName, 'search', filter);
	}

	resetFilterProfileApi() {
		this.ngrxService.resetFilter(this.serviceName, 'search');
	}

	resetState() {
		this.ngrxService.resetState(this.serviceName, 'search');
	}

	deleteProfile(eventId) {
		this.ngrxService.deleteFromState(this.serviceName, 'search', eventId);
	}
}
